import axios from "@/axios";
export default {
  resetImportParcels(context) {
    context.commit("resetImportParcels");
  },
  importParcels(context, payload) {
    context.commit("setImportParcels", payload);
  },
  async getLogistics(context) {
    try {
      await axios.get("/GetLogistic").then((res) => {
        // console.log("getLogistic11=", res.data.data);
        context.commit("setLogistics", res.data.data);
      });
    } catch (err) {
      console.log(err.message);
    }
  }, 
  async getBoxTypes(context) {
    try {
      await axios.get("/GetParcelType").then((res) => {
        // console.log("setBoxTypes=", res.data.data);
        context.commit("setBoxTypes", res.data.data);
      });
    } catch (err) {
      console.log(err.message);
    }
  },
  async getUnits(context, payload) {    
    try {
      await axios.get("/getUnits/" + payload).then((res) => {
        // console.log("getCustomerInUnit=", res.data.data);
        context.commit("setUnits", res.data.data);
      });
    } catch (err) {
      console.log(err.message);
    }
  },
  async getCustomers(context, payload) {    
    try {
      await axios.get("/GetDataCustomer/" + payload).then((res) => {
        // console.log("GetDataCustomer=", res.data.data);
        context.commit("setCustomers", res.data.data);
      });
    } catch (err) {
      console.log(err.message);
    }
  },
  async getBarcodes(context, payload) {    
    try {
      await axios.post("/getBarcodes", payload).then((res) => {
        // console.log("getCustomerInUnit=", res.data.data);
        context.commit("setBarcodes", res.data.data);
      });
    } catch (err) {
      console.log(err.message);
    }
  },
  async getLotParcel(context, payload) {
    try {
      // console.log("getLotParcel_payload=", payload); 
      await axios.post("/GetLotParcel", payload).then((res) => {
        // console.log("getLotParcel=", res.data.data.LT_RUNNO); 
        context.commit("setLotParcel", res.data.data.LT_RUNNO);
      });
    } catch (err) {
      console.log(err.message);
    }
  },
};
